// Shared by the Excel imports (students, staff).
export const imports = {
  'import.subtitle': 'ملف .xlsx أو .csv، حتى ٥٠٠ سطر في الدفعة الواحدة',
  'import.step1': '١. نزّل القالب واملأه',
  'import.template': 'تنزيل القالب (CSV)',
  'import.requiredHint': 'الأعمدة الداكنة إلزامية.',
  'import.step2': '٢. ارفع الملف',
  'import.choose': 'اختر ملفاً',
  'import.drop': 'أو اسحبه وأفلته هنا',
  'import.reading': 'جارٍ قراءة الملف…',
  'import.readError': 'تعذّرت قراءة الملف. تأكد أنه .xlsx أو .csv وأن السطر الأول هو العناوين.',
  'import.empty': 'الملف لا يحتوي على أسطر بيانات.',
  'import.fileInfo': '{name}، {n}',
  'import.change': 'تغيير الملف',
  'import.missing': 'أعمدة إلزامية غير موجودة: {cols}',
  'import.unknown': 'أعمدة غير معروفة ستُتجاهل: {cols}',
  'import.step3': '٣. افحص ثم استورد',
  'import.check': 'فحص الملف',
  'import.checking': 'جارٍ الفحص… {done} من {total}',
  'import.run': 'استيراد {n}',
  'import.running': 'جارٍ الاستيراد… {done} من {total}',
  'import.valid': '{valid} من {total} سطر صالح',
  'import.allValid': 'كل الأسطر صالحة ({n}). لا شيء يُحفظ قبل الضغط على «استيراد».',
  'import.hasIssues': 'وُجدت {n}. صحّح الملف ثم ارفعه من جديد؛ لا يُحفظ شيء ما دامت هناك مشكلات.',
  'import.done': 'استُورد {n}',
  'import.partial': 'استُورد {done} ثم توقف الاستيراد عند السطر {row}. لا تُعِد رفع الأسطر المستوردة.',
  'import.again': 'استيراد ملف آخر',
  'import.issues': 'المشكلات',
  'import.row': 'السطر',
  'import.field': 'الحقل',
  'import.problem': 'المشكلة',
  'import.preview': 'معاينة ({shown} من {n})',
  'import.issue.required': 'قيمة مطلوبة',
  'import.issue.invalid': 'قيمة غير مقبولة',
  'import.issue.phone': 'رقم هاتف غير صحيح',
  'import.issue.date': 'تاريخ غير صحيح (YYYY-MM-DD)',
  'import.issue.money': 'مبلغ غير صحيح',
  'import.issue.sameRow': 'مكرر مع السطر {row}',
};
